const AnimatedText = ({
  text,
  containerClassname,
  containerStyle = {},
  animationType = "wave",
  size = "small" // "small" | "large"
}) => {
  return (
    <div className={`animated-text animated-text--${size} ${containerClassname}`} style={containerStyle}>
      {text.split("").map((character, index, array) => (
        <span
          key={index}
          className={`animated-text-char animated-text-char--${animationType}`}
          style={{
            animationDelay: `${index * (0.8 / array.length)}s`,
          }}
        >
          {/* Preserve spaces by explicitly using the unicode hexadecimal code for the character */}
          {character === " " ? "\u00A0" : character}
        </span>
      ))}
    </div>
  );
};

export default AnimatedText;